import { NAV_ACTIONS, NavActionsConfig } from './actions';

// CP/GL-specific action configuration
export const PPNavActionsConfig: NavActionsConfig = {
    agentActions: [
        NAV_ACTIONS.NOTES,
        NAV_ACTIONS.SUBMISSION_MESSAGES,
        NAV_ACTIONS.LOCS_ADD,
        NAV_ACTIONS.LOCS_REMOVE,
        NAV_ACTIONS.EDIT_POLICY,
        NAV_ACTIONS.CANCEL,
        NAV_ACTIONS.RENEW,
    ],
    accountManagerActions: [
        NAV_ACTIONS.NOTES,
        NAV_ACTIONS.SUBMISSION_MESSAGES,
        NAV_ACTIONS.CREATE_CLAIM,
        NAV_ACTIONS.ENDORSE_POLICY,
        NAV_ACTIONS.VOID,
        NAV_ACTIONS.RESTORE,
        NAV_ACTIONS.CANCEL,
        NAV_ACTIONS.NOTICES,
        NAV_ACTIONS.EXTEND,
    ],
    adminActions: [
        NAV_ACTIONS.NOTES,
        NAV_ACTIONS.SUBMISSION_MESSAGES,
        NAV_ACTIONS.CREATE_CLAIM,
        NAV_ACTIONS.LOCS_ADD,
        NAV_ACTIONS.LOCS_REMOVE,
        NAV_ACTIONS.ENDORSE_POLICY,
        NAV_ACTIONS.VOID,
        NAV_ACTIONS.RESTORE,
        NAV_ACTIONS.CANCEL,
        NAV_ACTIONS.NOTICES,
        NAV_ACTIONS.EXTEND,
        NAV_ACTIONS.RENEW,
    ],
    underwriterActions: [
        NAV_ACTIONS.NOTES,
        NAV_ACTIONS.SUBMISSION_MESSAGES,
        NAV_ACTIONS.CREATE_CLAIM,
        NAV_ACTIONS.ENDORSE_POLICY,
        NAV_ACTIONS.VOID,
        NAV_ACTIONS.RESTORE,
        NAV_ACTIONS.CANCEL,
        NAV_ACTIONS.NOTICES,
        NAV_ACTIONS.EXTEND,
    ],
    auditRepActions: [NAV_ACTIONS.NOTES],
};
